import { mapSearchSessionSearchEventToSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import type { Search_3_0_0 } from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

function useTrackingSearchEvent({
  searchSessionSearchEvent,
  sortWasApplied,
  filterWasApplied,
}: {
  searchSessionSearchEvent?: App.SearchEvent
  sortWasApplied: boolean
  filterWasApplied: boolean
}): Search_3_0_0 {
  if (searchSessionSearchEvent) {
    return mapSearchSessionSearchEventToSearchEvent({
      searchEvent: searchSessionSearchEvent,
    })
  }

  if (sortWasApplied) {
    return mapSearchSessionSearchEventToSearchEvent({
      searchEvent: { type: 'sort' },
    })
  }

  if (filterWasApplied) {
    return mapSearchSessionSearchEventToSearchEvent({
      searchEvent: { type: 'filters' },
    })
  }

  return mapSearchSessionSearchEventToSearchEvent({
    searchEvent: undefined,
  })
}

export default useTrackingSearchEvent
